// extracted by mini-css-extract-plugin
export default {"text":"PayWithButton_text__Lf8ys","btntxt":"PayWithButton_btntxt__Mhehe"};